module.exports = __webpack_public_path__ + "static/media/LAUNCHPADHEADER-min.195ddd5a.jpeg";